import classNames from "classnames/bind";
import * as React from "react";
import * as styles from "./Radio.less";

export type RadioValueType = string | number | string[];

export interface RadioProps {
    title: string;
    value: RadioValueType;
    name?: string;
    disabled?: boolean;
    selectedValue?: RadioValueType;
    onSelect?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onlyRadio?: boolean;
}

export const RadioElement: React.FC<RadioProps> = ({
    value,
    title,
    name,
    onSelect,
    selectedValue,
    disabled,
    onlyRadio,
}) => {
    return (
        <label className={classNames(styles.radio, disabled && styles.disabled, onlyRadio && styles.only_radio)}>
            <input
                className={styles.input}
                type="radio"
                name={name}
                value={value}
                onChange={onSelect}
                checked={value === selectedValue}
                disabled={disabled}
            />
            <div className={styles.label}>{title}</div>
        </label>
    );
};
